import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroButtons = () => {
  return (
    <div className="flex flex-col sm:flex-row justify-center gap-4">
      <a
        href="https://my.europeanstudent.org/"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center px-6 md:px-8 py-3 rounded-full bg-[#0139B7] text-white hover:bg-[#012d8f] transition-all transform hover:scale-105"
      >
        Sign Up
        <ArrowRight className="ml-2 h-5 w-5" />
      </a>
      <Link
        to="/about"
        className="inline-flex items-center justify-center px-6 md:px-8 py-3 rounded-full border-2 border-[#0139B7] text-[#0139B7] hover:bg-[#0139B7] hover:text-white transition-all transform hover:scale-105"
      >
        Learn More
      </Link>
    </div>
  );
};

export default HeroButtons;